import request from "@/router/axios";

// 多维度运输数据智能统计 - 列表
export const getList = (data = {}) => {
  const { page, ...rest } = data || {};
  // crud-mixins 传入的是 page/size，这里转换为后端需要的 current/size
  const payload = { ...rest };
  if (page !== undefined && page !== null) payload.page = page;
  return request({
    url: "/api/produce/stock-management/select/page",
    method: "post",
    data: payload,
  });
};
